import React, {Fragment, useRef, useEffect} from 'react';
import {GoogleMap, Marker} from "@react-google-maps/api";
import "../assets/category-colors.css";

// Function to get category color from CSS variables
const getCategoryColor = (categoryId) => {
    const colorMap = {
        1: '#73456F',   // Nuklearmedizin
        2: '#108F64',   // Radiojodtherapie
        3: '#E0003A',   // Chirurgie
        4: '#F7CB24',   // Rehabilitation
        5: '#315596',   // Thermoablation
        6: '#b06c27',   // Endokrinologie
        7: '#5AA5DC',   // HNO
        8: '#108F64',   // Rehabilitation (alternative)
        9: '#FF6D00',   // Thermoablation (alternative)
        12: '#9C27B0',  // Endokrinologie (alternative)
        13: '#5AA5DC'   // HNO (alternative)
    };
    return colorMap[categoryId] || '#757575';
};

// Function to create CSS-based marker icon
const createMarkerIcon = (categoryId) => {
    const color = getCategoryColor(categoryId);
    const svgIcon = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='enable-background:new 0 0 30 30' viewBox='0 0 30 30'%3E%3Ccircle cx='15' cy='15' r='14' fill='${encodeURIComponent(color)}' stroke-width='2'/%3E%3Cpath d='M21.4 4.9c-.2.9-.4 1.7-.8 2.5-.3.8-.7 1.6-1.2 2.3-.5.7-1.2 1.3-2 1.7-.8.4-1.7.6-2.5.5-.9 0-1.7-.2-2.6-.5-.8-.3-1.6-.6-2.4-1-.4-.2-.7-.4-1.1-.6-.2-.1-.4-.2-.6-.4 0 0-.4-.2-.5-.4-.6-.5-1.1-1.1-1.4-1.9l-.1-.2C6.1 7 6 7 6 7c-.3.2-.6.3-.9.3-.1-.1-.3-.1-.4-.3-.2-.1-.3-.2-.4-.4.1.2.2.4.3.5.1.1.3.3.5.3h.6c.1 0 .3-.1.3-.1.1.4.3.7.5 1 .3.4.5.7.9 1 .2.2.6.5.6.5.2.1.4.2.5.4.4.2.8.5 1.1.7.8.4 1.6.8 2.5 1.1.4.1.9.3 1.3.4.5.1.9.1 1.4.1.9 0 1.9-.2 2.8-.6.4-.2.8-.5 1.2-.8.3-.3.6-.7.9-1.1.3-.4.5-.8.7-1.2.2-.4.4-.8.5-1.2.3-.9.4-1.8.5-2.7' style='fill:%23fff'/%3E%3Cpath d='M6.6 8.5v.2c0 .2.1.3.1.6 0 .2.1.5.1.7.1.4.2.6.2.9 0 .3 0 .6.1 1 0 .3 0 .7.1 1V14c0 .4 0 .7-.1 1.1 0 .1-.1.2-.1.3 0 .1-.2.3-.2.3-.1.2-.3.3-.4.4-.6.4-1.2.7-1.7.8-.5.1-1 .2-1.3.2h-.5s.2 0 .5-.1.8-.1 1.3-.3c.5-.2 1.1-.4 1.6-.8.2-.2.5-.5.5-.8.1-.3.1-.7.1-1.1v-2.1c0-.7-.1-1.3-.1-1.8 0-1.1-.1-1.7-.1-1.7-.1 0-.1.1-.1.1m11.3 5.9c-.2-1.2-.4-1.7-.9-1.7-.5.1-1.1 1.2-1.3 1.6-.1.3-.3.7-.5.8-.3.1-.6 0-1 0-.3 0-.4 0-.8-.4-.2-.2-.4-.4-.6-.8-.7-1.1-1.3-1.7-1.8-1.6-.4.1-1.1.4-1.3 2-.1.6-.1 1.2 0 1.9.3 2.2 1.3 3.4 2 3.7.1 0 .2.1.3.1.4 0 .8-.3 1.2-.5l.6-.3c.3-.2.9-.5 1.2-.3.2.1.5.5.6.6.2.2.8.8 1.5-.6s.9-3.3.8-4.5' style='fill:%23fff'/%3E%3Cpath d='M17.4 2.5c5 1.4 8.7 6.1 8.7 11.6 0 6.6-5.4 12-12 12-5.5 0-10.1-3.7-11.6-8.7 1.2 5.8 6.3 10.1 12.4 10.1 7 0 12.6-5.6 12.6-12.6 0-6.1-4.4-11.2-10.1-12.4' style='fill:%23fff'/%3E%3Cpath d='M19 11.4c0 .3 0 .8.1 1.3 0 .6.1 1.2.1 1.9 0 .3.1.7.1 1 .1.3.2.7.3.9.2.2.4.5.7.6.3.2.6.3.9.5l.9.3.9.3c.5.1 1 .3 1.3.4.3.1.5.1.5.1s-.7-.1-1.8-.3c-.5-.1-1.2-.3-1.8-.5-.3-.1-.7-.3-1-.5-.3-.2-.6-.4-.9-.7-.2-.3-.3-.7-.4-1.1-.1-.4-.1-.7-.1-1.1v-1.9c0-1.1.1-1.6.1-1.6 0 .1 0 .1.1.4m-2.1-7.5h-.2c-.1 0-.8-.4-1.8.3-.3.2-.8.6-.8.6l-.2.2s-.1.1 0 .1 1-.7 1.3-.8.7-.2 1-.2c.3.1.4.1.5.1h.2c.1 0 .8-.2 1.2.1.4.3.5.6.7.8.2.2.3.3.5.4 0 0-.4-.5-.5-.8-.2-.3-.4-.8-1.2-.9-.4.1-.7.1-.7.1' style='fill:%23fff'/%3E%3Cpath d='M18.9 5.8s.1.1 0 0c-.1 0-1-.6-1.9-.6h-1.1c-.3-.1-.7-.1-1 0s-1.3.2-1.9 0c-.2 0-.1-.1 0 0s1.1 0 1.8-.2.8-.1 1.3-.1 1.2.1 1.5.2c.2.1.6.2 1.3.7m-.4.3s.1 0 0 0c-.1.1-.8.4-2.3.3s-2.4-.6-2.4-.6-.1-.1 0 0c.1 0 1.6.3 2.5.4.9 0 1.8 0 2.2-.1' style='fill:%23fff'/%3E%3C/svg%3E`;

    return {
        url: svgIcon,
        scaledSize: new window.google.maps.Size(32, 32),
        anchor: new window.google.maps.Point(16, 16)
    };
};

const MapView = (props) => {
    const mapRef = useRef(null);
    const markersRef = useRef([]);

    const addMarkersToMap = (map, members) => {
        try {
            // Check if Google Maps is available
            if (!window.google || !window.google.maps) {
                console.warn('Google Maps API not yet loaded');
                return;
            }

            // Clear any existing markers
            markersRef.current.forEach(marker => marker.setMap(null));
            markersRef.current = [];

            // Add member markers with custom icons
            if (members && members.length > 0) {
                // Get filtered categories from props
                const filteredCategories = props.filter?.categories || [];

                members.forEach((member, index) => {
                    const lat = parseFloat(member.member_latitude);
                    const lng = parseFloat(member.member_longitude);

                    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                        // Get category for custom icon
                        // If filtering by category, use the filtered category color instead of primary
                        let categoryId = parseInt(member.member_primary_category_id);
                        // Fallback: if no valid primary category, use first from member_category_ids
                        if ((!categoryId || isNaN(categoryId)) && member.member_category_ids) {
                            const firstCategory = member.member_category_ids.split(',')[0]?.trim();
                            if (firstCategory) {
                                categoryId = parseInt(firstCategory);
                            }
                        }

                        if (filteredCategories.length > 0 && member.member_category_ids) {
                            const memberCategories = member.member_category_ids.split(',').map(c => c.trim());
                            // Find first matching filtered category
                            const matchedCategory = filteredCategories.find(fc =>
                                memberCategories.includes(fc.toString())
                            );
                            if (matchedCategory) {
                                categoryId = parseInt(matchedCategory);
                            }
                        }

                        const customIcon = createMarkerIcon(categoryId);

                        const marker = new window.google.maps.Marker({
                            position: { lat, lng },
                            map: map,
                            title: member.member_post_title,
                            icon: customIcon
                        });

                        // Add click listener
                        marker.addListener('click', () => {
                            if (props.onMarkerClick) {
                                props.onMarkerClick(null, member, index);
                            }
                        });

                        markersRef.current.push(marker);
                    }
                });
            }
        } catch (error) {
            console.error('Error adding markers to map:', error);
        }
    };

    const onMapLoad = (map) => {
        mapRef.current = map;
        addMarkersToMap(map, props.members);
    };

    useEffect(() => {
        if (mapRef.current && props.members) {
            addMarkersToMap(mapRef.current, props.members);
            fitMapToMarkers(mapRef.current, props.members);
        }
    }, [props.members]);

    const fitMapToMarkers = (map, members) => {
        try {
            if (!map || !window.google || !window.google.maps) {
                return;
            }

            if (!members || members.length === 0) {
                // No members, use default center and zoom
                map.setCenter({ lat: 50.8835239, lng: 10.2 });
                map.setZoom(6);
                return;
            }

            // Get valid member locations
            const validMembers = members.filter(member => {
                const lat = parseFloat(member.member_latitude);
                const lng = parseFloat(member.member_longitude);
                return !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
            });

            if (validMembers.length === 0) {
                // No valid locations, use default center and zoom
                map.setCenter({ lat: 50.8835239, lng: 10.2 });
                map.setZoom(6);
                return;
            }

            if (validMembers.length === 1) {
                // Single member, center on them with good zoom level
                const member = validMembers[0];
                map.setCenter({
                    lat: parseFloat(member.member_latitude),
                    lng: parseFloat(member.member_longitude)
                });
                map.setZoom(12);
                return;
            }

            // Multiple members, fit bounds to show all
            const bounds = new window.google.maps.LatLngBounds();
            validMembers.forEach(member => {
                bounds.extend({
                    lat: parseFloat(member.member_latitude),
                    lng: parseFloat(member.member_longitude)
                });
            });

            map.fitBounds(bounds, {
                top: 100,
                right: 50,
                bottom: 100,
                left: 100
            });

            // Ensure zoom stays within reasonable bounds
            setTimeout(() => {
                if (map.getZoom && typeof map.getZoom === 'function') {
                    const currentZoom = map.getZoom();
                    if (currentZoom > 15) {
                        map.setZoom(15);
                    } else if (currentZoom < 6.4) {
                        map.setZoom(6.4);  // Mindest-Zoom wenn nicht gefiltert
                    }
                }
            }, 100);
        } catch (error) {
            console.error('Error fitting map to markers:', error);
        }
    };

    return (
        <Fragment>
            <div style={{ height: '100%', width: '100%' }}>
                <GoogleMap
                    mapContainerStyle={{
                        width: '100%',
                        height: props.mapProps?.height || 'calc(100vh - 83px)'
                    }}
                    center={props.mapProps?.center || { lat: 51.1657, lng: 10.4515 }}
                    zoom={props.mapProps?.zoom || 8}
                    onLoad={onMapLoad}
                >
                    {/* All markers are added directly via API now */}
                </GoogleMap>
            </div>
        </Fragment>
    );
};

export default MapView;
